import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../../../service";

import {
    deletedRestoreScientificDegrees,
    deletedScientificDegree,
    setScientificDegree,
    setScientificDegreesRestoreData,
    updateScientificDegree,
} from "./scientificDegreeSlice";
import { IErrorResponse } from "../../../../../../types";
import { IScientificDegreeCreate, IScientificDegreePayload } from "../types";

const SetScientificDegree = createAsyncThunk(
    "create/scientific-degrees",
    async (data: IScientificDegreeCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/scientific-degrees", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetScientificDegrees = createAsyncThunk("get/scientific-degrees", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get("/scientific-degrees");

        dispatch(setScientificDegree({ data: response.data }));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeleteScientificDegree = createAsyncThunk(
    "delete/scientific-degrees",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.delete(`/scientific-degrees/${id}`);

            dispatch(deletedScientificDegree(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditScientificDegree = createAsyncThunk(
    "edit/scientific-degrees",
    async (data: IScientificDegreePayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/scientific-degrees/${data.id}`, data);
            dispatch(updateScientificDegree(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteScientificDegrees = createAsyncThunk(
    "get/delete/scientific-degrees",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get(`/scientific-degrees/deleted-items`);

            dispatch(setScientificDegreesRestoreData(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const RestoreDeleteScientificDegrees = createAsyncThunk(
    "restore/delete/scientific-degrees",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/scientific-degrees/restore/${id}`);

            dispatch(deletedRestoreScientificDegrees(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    GetScientificDegrees,
    DeleteScientificDegree,
    EditScientificDegree,
    SetScientificDegree,
    RestoreDeleteScientificDegrees,
    GetDeleteScientificDegrees,
};
